export default function ($translate) {
    return {
        KEYS: {
            ET: 'ET',
            EN: 'EN',
            LV: 'LV',
            LT: 'LT',
            RU: 'RU',
            NO: 'NO'
        },
        LABELS: {
            ET: $translate.instant('occurrence.language.Estonian'),
            EN: $translate.instant('occurrence.language.English'),
            LV: $translate.instant('occurrence.language.Latvian'),
            LT: $translate.instant('occurrence.language.Lithuanian'),
            RU: $translate.instant('occurrence.language.Russian'),
            NO: $translate.instant('occurrence.language.Norwegian')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/occurrence/language/index.js